import { generatePath } from "react-router";

import { useFeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { UserStatus } from "@vega-api/generated/types/userStatus";
import { ActionMenu } from "@vega-core/components/ActionMenu/ActionMenu";
import { useBoolean } from "@vega-core/hooks/useBoolean";
import { m } from "@vega-core/paraglide/messages";

import { VegaModulesPaths } from "../../../../../paths";
import { ResendInviteModal } from "../modals/ResendInviteModal";

type Props = {
  userId: string;
  status?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
};

export const UserMenu = ({
  userId,
  status,
  email,
  firstName,
  lastName,
}: Props) => {
  const isResendModalOpen = useBoolean(false);
  const { featureFlag } = useFeatureFlag();
  const menuItems = (() => {
    if (status === UserStatus.INVITED) {
      if (featureFlag.lp_settings_resend_invitations && email) {
        return [
          {
            title: m.btn_resend(),
            onClick: isResendModalOpen.setTrue,
          },
        ];
      }

      return [];
    }

    return [
      {
        title: m.btn_viewUser(),
        onClick: () => {
          window.location.href = generatePath(VegaModulesPaths.SettingsUser, {
            id: userId,
          });
        },
      },
    ];
  })();

  return (
    <>
      <ActionMenu menuItems={menuItems} variant="tertiary" />
      {email ? (
        <ResendInviteModal
          invitationVariant="investor-investor"
          onClose={isResendModalOpen.setFalse}
          open={isResendModalOpen.value}
          user={{
            id: userId,
            email,
            firstName,
            lastName,
          }}
        />
      ) : null}
    </>
  );
};
